import { useQuery } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth';
import fetchBrandsData from '../Services/fetchBrandsData';

export default function useBrandsData() {
	const { accessToken } = useAuth();

	const brandsQuery = useQuery({
		queryKey: ['brands'],
		queryFn: () => fetchBrandsData({ accessToken }),
		staleTime: Infinity,
		retry: false,
	});

	return brandsQuery;
}
